const SubTitle = ({ title }) => {
  return (
    <p className="phoneTitle inline text-[#A1A1A1] font-[700] mb-0">{title}</p>
  );
}

export default SubTitle;